import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "nav-bar-menu"
};
const _hoisted_2 = {
  key: 0,
  class: "flex-col flex-centered nav-tab-tryfreebtn-container"
};
import { inject } from 'vue';
import TryFreeBtn from '@/components/TryFreeBtn.vue';
import NavBarProductDropdown from './NavBarProductDropdown.vue';
import NavBarSimpleDropdown from './NavBarSimpleDropdown.vue';
import NavBarHeaderTag from './NavBarHeaderTag.vue';
export default {
  __name: 'NavBarMenu',
  setup(__props) {
    const user = inject('user');
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavBarHeaderTag, {
        to: {
          name: 'Subscriptions',
          params: {
            slug: 'unlimited'
          }
        }
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("h3", {
          class: "nav-tab-header"
        }, " AutoTune Unlimited ", -1)])),
        _: 1
      }), _createVNode(NavBarProductDropdown, {
        "aria-label": "Products Dropdown"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("h3", {
          class: "nav-tab-header"
        }, " Products ", -1)])),
        _: 1
      }), _createVNode(NavBarHeaderTag, {
        href: "https://shop.autotune.com/"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("h3", {
          class: "nav-tab-header"
        }, " Merch ", -1)])),
        _: 1
      }), _createVNode(NavBarSimpleDropdown, {
        "aria-label": "Learning Dropdown"
      }, {
        "dropdown-content": _withCtx(() => [_createVNode(_component_router_link, {
          to: {
            name: 'Community'
          }
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("h4", null, "Blog", -1)])),
          _: 1
        }), _createVNode(_component_router_link, {
          to: {
            name: 'LearningCenter'
          }
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("h4", null, "Tutorials", -1)])),
          _: 1
        }), _createVNode(_component_router_link, {
          to: {
            name: 'Artists'
          }
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("h4", null, "Artists", -1)])),
          _: 1
        })]),
        default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("h3", {
          class: "nav-tab-header"
        }, " Learning ", -1))]),
        _: 1
      }), _createVNode(NavBarSimpleDropdown, {
        "aria-label": "Support Dropdown"
      }, {
        "dropdown-content": _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("a", {
          href: "https://antaresaudiotechnologies.my.site.com/s/",
          target: "_blank",
          rel: "noopener noreferrer"
        }, [_createElementVNode("h4", null, "Customer Service")], -1)), _cache[13] || (_cache[13] = _createElementVNode("a", {
          href: "https://antaresaudiotechnologies.my.site.com/s/topic/0TO4V000000oNAZWA2/faqs/",
          target: "_blank",
          rel: "noopener noreferrer"
        }, [_createElementVNode("h4", null, "FAQ")], -1)), _createVNode(_component_router_link, {
          to: {
            name: 'WPPageRenderer',
            params: {
              slug: 'getting-started'
            }
          }
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("h4", null, "Getting Started", -1)])),
          _: 1
        }), _createVNode(_component_router_link, {
          to: {
            name: 'SoftwareDownload'
          }
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("h4", null, "Download Manager", -1)])),
          _: 1
        }), _createVNode(_component_router_link, {
          to: {
            name: 'DiscontinuedSoftwareDownload'
          }
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("h4", null, "Legacy Installers", -1)])),
          _: 1
        }), _createVNode(_component_router_link, {
          to: {
            name: 'Documentation'
          }
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [_createElementVNode("h4", null, "Product Manuals", -1)])),
          _: 1
        }), _createVNode(_component_router_link, {
          to: {
            name: 'WPPageRenderer',
            params: {
              slug: 'daw-compatibility'
            }
          }
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("h4", null, "DAW Compatibility", -1)])),
          _: 1
        })]),
        default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("h3", {
          class: "nav-tab-header"
        }, " Support ", -1))]),
        _: 1
      }), _createVNode(NavBarHeaderTag, {
        to: {
          name: 'WPPageRenderer',
          params: {
            slug: 'auto-tune-special-offers'
          }
        }
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("h3", {
          class: "nav-tab-header"
        }, " Special Offers ", -1)])),
        _: 1
      }), !(_unref(user).isSubscriber || _unref(user).isTrialer) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(TryFreeBtn)])) : _createCommentVNode("", true)]);
    };
  }
};